import { useEffect, useState } from "react";
import { useMainContext } from "../../../Context";
import { userDashboard } from "../../../Utils/Apis";

export const useDashboard = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const { post } = useMainContext();
  const get = async () => {
    setLoading(true);
    const { data } = await post(userDashboard, {});
    setData(data);
    setLoading(false);
  };
  useEffect(() => {
    get();
  }, []);

  return { data, loading };
};
